import {
  getV1CompaniesCompanyIdServices,
  GetV1CompaniesCompanyIdServicesData,
  Service_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { Service } from '~hooks/useServices/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Service_Read,
  Service,
  GetV1CompaniesCompanyIdServicesData
> & { companyId: string };

export default function AutocompleteCompanyServices<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteCompanyServices"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdServices,
      }}
      parseFn={(item: Service_Read) => {
        const parsed = Service.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
